import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { IntlProvider, injectIntl, intlShape } from 'react-intl';
import { canUseDOM } from 'exenv';

import { Location } from 'models/locations';
import Booking from 'models/booking';
import Brand from 'models/brand';
import Review from 'models/review';

import PastBookingModal from 'components/bookings/past/past-booking-modal';
import ViewReceipt from 'components/bookings/links/view-receipt';
import PrevArrow from 'components/svgs/icons/prev-arrow';

const propTypes = {
  close: PropTypes.func.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  display: PropTypes.bool.isRequired,
  booking: PropTypes.instanceOf(Booking),
  location: PropTypes.instanceOf(Location),
  review: PropTypes.instanceOf(Review),
  reviewBooking: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

const defaultProps = {
  booking: null,
  location: null,
  review: null,
};


/*
 * WARNING: This way of doing mobile modals is extremely deprecated.
 *
 * We had to do it at one point for performance reasons when pages did
 * not have access to the entire DOM. For example, the old account page
 * that was half-managed with PHP and half-managed with React.
 */

class ModalWrapper extends Component {
  componentWillMount() {
    if (canUseDOM) {
      this._target = document.createElement('div');
      const app = document.getElementById('content-wrapper');
      const appContent = document.getElementById('content');
      app.insertBefore(this._target, appContent);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!nextProps.display || !this.props.display) { return true; }

    return false;
  }

  componentDidUpdate() {
    const content = document.getElementById('non-header-content');

    if (!this.props.display) {
      // Hide the modal
      ReactDOM.render(<div />, this._target);

      // Display the rest of the content;
      content.className = content.className.replace(/\b hidden\b/, '');
    } else {
      const modal = (
        <IntlProvider locale={this.props.intl.locale} messages={this.props.intl.messages}>
          <div id="search-time-form" className="datepair fade" data-keyboard="false" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="mobile-modal-dialog">
              <div className="mobile-modal-body">
                <div className="area bookings past-bookings-modal">
                  <div className="row booking-row">
                    <div className="col-xs-7 col-gutter-right-0 grid-header link back-to-bookings" onClick={this.props.close}>
                      <PrevArrow /><span>Back to Parking</span>
                    </div>
                    <div className="col-xs-5 col-gutter-left-0 text-right">
                      <ViewReceipt booking={this.props.booking} />
                    </div>
                  </div>
                  <div className="row">
                    <PastBookingModal
                      booking={this.props.booking}
                      location={this.props.location}
                      brand={this.props.brand}
                      review={this.props.review}
                      reviewBooking={this.props.reviewBooking}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </IntlProvider>
      );

      // Hide the rest of the content
      content.className += ' hidden';

      // Render Modal
      ReactDOM.render(modal, this._target);

      // Jump to Page
      window.scrollTo(0, 0);
    }
  }

  render() {
    return null;
  }
}

ModalWrapper.propTypes = propTypes;
ModalWrapper.defaultProps = defaultProps;

export default injectIntl(ModalWrapper);
